import ApplicationForm from './ApplicationForm';
export default ApplicationForm;
